export default __webpack_public_path__ + "static/media/74.3380e4f1.jpg";